import { useCallback, useMemo } from 'react';

import { Button } from '@mui/material';
import { RiFileExcel2Fill } from 'react-icons/ri';

import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';

interface RelatorioContaCorrenteBtnProps {
    disabled: boolean;
}

export function RelatorioContaCorrenteBtn({ disabled }: RelatorioContaCorrenteBtnProps) {
    const { filter } = useListagemContext();

    const requestOptions: RequestOptionsType = useMemo(
        () => ({
            url: '/financeiro/royaltyrelatorio/conta/corrente',
            columns: 'idRelatorioContaCorrenteCobranca',
            filter,
        }),
        [filter],
    );

    const { isLoadingFile, downloadFile } = useDownloadFile({
        requestOptions,
    });

    const handleClickDownload = useCallback((): void => {
        downloadFile({
            newRequestOptions: requestOptions,
            directDownload: true,
        });
    }, [downloadFile, requestOptions]);

    return (
        <Button
            loading={isLoadingFile}
            variant="outlined"
            color="success"
            onClick={handleClickDownload}
            disabled={disabled || isLoadingFile}
            startIcon={<RiFileExcel2Fill />}
        >
            CONTA CORRENTE COBRANÇA ROYALTIES
        </Button>
    );
}
